// extracted by mini-css-extract-plugin
export var container = "_6j-1";
export var cornerButtonContainer = "_6j-5";
export var disabled = "_6j-2";
export var fileContainer = "_6j-4";
export var hiddenInput = "_6j-3";
export var widthContainer = "_6j-0";